/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import LeftSide from "../LeftSide/LeftSide";
import RightSide from "../RightSide/RightSide";
import { useStyles } from "../styles";

const ContentContainer = () => {
  const { contentContainer } = useStyles();

  return (
    <div css={css(contentContainer)} className="scrollable">
      <LeftSide />
      <RightSide />
    </div>
  );
};

export default ContentContainer;
